import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { MiscellaneousSettingKeyConstant } from "../../../constants/miscellaneous-setting-key-constant";
import { useStore } from "../../../contexts/store-provider";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";
import CustomerTopNavBar from "../../../shared-components/navbar/customer-top-navbar";
import StoreListView from "./components/store-list-sidebar";
import "./store-list.css";
import { StoreCmsStore } from "../../../core/stores/store-cms-store";
import StoreSelectionView from "./components/store-selection-view";

const StoreListPage: React.FC = () => {
  const {
    masterManagementStore,
    storeCmsStore,
    storeManagementStore,
  } = useStore();
  const {
    GetMiscellaneousSettingByKeyService,
    resetGetMiscellaneousSettingByKeyState,
    getMiscellaneousSettingByKeyDetail,
    getMiscellaneousSettingByKeyState,
  } = masterManagementStore;
  const {
    GetCmsBusinessTypeConditionalService,
    cmsBusinessTypeConditional,
    cmsBusinessTypeConditionalState,
  } = storeCmsStore;
  const {
    GetAllPrefectureOptionService,
    allprefectureOptionsState,
    resetAllprefectureOptionsState,
  } = storeManagementStore;

  useEffect(() => {
    GetMiscellaneousSettingByKeyService(
      MiscellaneousSettingKeyConstant.ShowFilter
    );
    GetAllPrefectureOptionService();
    return () => {
      new StoreCmsStore().resetStoreCodeDetails();
      resetGetMiscellaneousSettingByKeyState();
      resetAllprefectureOptionsState();
    };
  }, []);

  useEffect(() => {
    if (getMiscellaneousSettingByKeyDetail) {
      GetCmsBusinessTypeConditionalService(true);
    }
  }, [getMiscellaneousSettingByKeyDetail]);

  return (
    <>
      <CustomerTopNavBar />
      {(getMiscellaneousSettingByKeyState.inProgress ||
        allprefectureOptionsState.inProgress ||
        cmsBusinessTypeConditionalState.inProgress) && (
        <FormLoader
          loading={
            getMiscellaneousSettingByKeyState.inProgress ||
            allprefectureOptionsState.inProgress ||
            cmsBusinessTypeConditionalState.inProgress
          }
        />
      )}
      <Container fluid className="store-list-page">
        {/* <StoreListView /> */}
        <StoreSelectionView />
      </Container>
    </>
  );
};

export default observer(StoreListPage);
